export { useWixCliAppBi } from './useWixCliAppBi.js';
